export default {module:'Card/List',view:'Element/List',options:{events:{onClick:'detail'},limit:3,md:12}}